// extracted by mini-css-extract-plugin
export default {"homeButtons":"HomeButtonComponent_homeButtons__WuRvs"};